import { IOfferScopeStatusLang } from '../../../types/lang'
import { EOfferScopeStatus } from '../../../types'

export const offerScopeStatusLang: IOfferScopeStatusLang = {
	offer_scope_status: {
		[EOfferScopeStatus.none]: 'none_ru',
		[EOfferScopeStatus.active]: 'active_ru',
		[EOfferScopeStatus.paused]: 'paused_ru',
		[EOfferScopeStatus.closed]: 'closed_ru',
	}
}